import { doc, getDoc } from 'firebase/firestore'
import { get } from 'lodash'

import parseDriverPathSegments from 'components/common/map/parseDriverPathSegments'
import { db } from 'providers/WithFirebase'

/**
 * One route-day's recorded track, read from the Firestore document the route's
 * geojson points at and parsed into the segment shape the overlays render.
 *
 * The document path lives here alone — three hooks were spelling it out
 * (`useDriverPathBreadcrumb`, `useRoutesDriverPathBreadcrumb`, the productivity
 * map's multi-day read), which is three places to fix when the collection moves.
 *
 * Returns null when there's no document to read, and an ARRAY when there is —
 * possibly empty, for a document holding no usable LineString. Callers depend on
 * that difference: null is "nothing recorded", `[]` is "recorded, nothing usable",
 * and only the first is worth retrying.
 */
export const readDriverPathSegments = async (businessId: string, routeDailyGeoJsonId: string): Promise<object[] | null> => {
  if (!businessId || !routeDailyGeoJsonId) return null
  const snapshot = await getDoc(doc(db, `crm_web/${businessId}/route_daily_geo_jsons/${routeDailyGeoJsonId}`)).catch(() => null)
  return snapshot?.exists() ? parseDriverPathSegments(get(snapshot.data(), 'driverPathGeoJson')) : null
}

export default readDriverPathSegments
